export const chatEndpoints = {
  sidebar: () => "/conversations/sidebar",
  messages: (conversationId: string) => `/conversations/${conversationId}/messages`,
  sharedFiles: (conversationId: string) => `/conversations/${conversationId}/files`,
  markRead: (conversationId: string) => `/conversations/${conversationId}/read`,
  typing: (conversationId: string) => `/conversations/${conversationId}/typing`,
  startDirect: () => "/conversations/direct",
  createGroup: () => "/groups",
  groupDetails: (groupId: string) => `/groups/${groupId}`,
  joinGroup: (groupId: string) => `/groups/${groupId}/join`,
  leaveGroup: (groupId: string) => `/groups/${groupId}/leave`,
  addMembers: (groupId: string) => `/groups/${groupId}/members`,
  removeMembers: (groupId: string) => `/groups/${groupId}/members`,
  renameGroup: (groupId: string) => `/groups/${groupId}`,
  updateMemberRole: (groupId: string, memberId: string) =>
    `/groups/${groupId}/members/${memberId}/role`,
  toggleBroadcast: (groupId: string) => `/groups/${groupId}/broadcast`,
  starMessage: (messageId: string) => `/messages/${messageId}/star`,
  subjectConversations: (subjectType: string, subjectId: string) =>
    `/conversations/subject/${subjectType}/${subjectId}`,
  createSubjectConversation: () => "/conversations/subject",
  sendMessage: () => "/messages",
  uploadFile: () => "/upload",
  blockUser: (targetUserId: string) => `/direct/${targetUserId}/block`,
  createPoll: (conversationId: string) => `/conversations/${conversationId}/polls`,
  votePoll: (pollId: string) => `/polls/${pollId}/vote`,
} as const;
